import React, { useState } from 'react';
import { cx } from './cx';

export interface AvatarProps {
  /** Used for the initials fallback and the image alt text. */
  name?: string;
  /** Shown when there is no image and no name (e.g. a user icon). */
  icon?: React.ReactNode;
  src?: string;
  size?: 'sm' | 'md';
  className?: string;
}

function initials(name = ''): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0][0] ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] ?? '' : '';
  return (first + last).toUpperCase();
}

/** Round avatar with an initials fallback. */
export default function Avatar({ name, icon, src, size = 'md', className }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  return (
    <span
      className={cx(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full border border-edge bg-inset font-ui font-semibold text-primary',
        size === 'sm' ? 'size-8 text-small' : 'size-10 text-body',
        className
      )}
    >
      {src && !failed ? (
        <img src={src} alt={name ?? ''} className="size-full object-cover" onError={() => setFailed(true)} />
      ) : name ? (
        <span>{initials(name)}</span>
      ) : icon ? (
        // The box fills the circle so the icon's percentage size resolves against the avatar and it sits dead centre.
        <span aria-hidden className="flex size-full items-center justify-center text-secondary [&>svg]:size-1/2">
          {icon}
        </span>
      ) : null}
    </span>
  );
}
